/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_TitleInputs */

const en_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Export`)
};

const fr_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de fichiers`)
};

const de_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiexport`)
};

const it_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione file`)
};

const ru_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт файла`)
};

const es_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de archivos`)
};

const zh_cn2_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件导出`)
};

const ja_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのエクスポート`)
};

const hi_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल निर्यात`)
};

const pt_pt2_file_export_title = /** @type {(inputs: File_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de Arquivos`)
};

/**
* | output |
* | --- |
* | "File Export" |
*
* @param {File_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_title = /** @type {((inputs?: File_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_title(inputs)
	if (locale === "de") return de_file_export_title(inputs)
	if (locale === "it") return it_file_export_title(inputs)
	if (locale === "ru") return ru_file_export_title(inputs)
	if (locale === "es") return es_file_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_title(inputs)
	if (locale === "ja") return ja_file_export_title(inputs)
	if (locale === "hi") return hi_file_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_title(inputs)
	return en_file_export_title(inputs)
});